import React, { useState, useRef, useEffect } from "react";
import SingpassImg from "../../img/singpass.png";
import { Button } from "app/(new-pages)/components/Button/pc/index.pc";
import { setCookie } from "helpers/cookies";
import { fetchAuthorizeUrl } from "store/services/newIndex";

const SingpassButton = ({ onClose }) => {
  const [disabled, setDisabled] = useState(true);
  const redirectUrl = useRef(null);

  useEffect(() => {
    const baseUrl = window.location.origin + "/singpass/callback";
    fetchAuthorizeUrl(baseUrl).then((res) => {
      const url = res.data?.data?.authorise_url;
      if (url) {
        redirectUrl.current = url;
        setDisabled(false);
      }
    });
  }, []);

  const handleSingpass = () => {
    if (redirectUrl.current) {
      const time = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
      const { origin, pathname } = window.location;
      let url = origin + pathname + "?showSingpassInfo=1";
      setCookie("singpassRedirectUrl", url, time);
      onClose();
      window.open(redirectUrl.current, "_target");
    }
  };
  return (
    <Button variant='redBtn' btnSize='size40' loading={disabled} onClick={handleSingpass}>
      <img src={SingpassImg.src} style={{ height: "15px" }} alt='singpass' />
    </Button>
  );
};

export default SingpassButton;
